import React, { useEffect } from 'react'
import { Text, Flex, Link, ArcadeIcon, MessageInline } from '@afterpaytouch/core'
import { Trans } from '../../../utils/convergence'
import { useTranslation } from '../../../utils/convergence'
import { useAppRouter, useIsAppleRetailOrder } from '../../../state'
import { Route } from '../../../config/router'
import styles from './style.module.css'
import { useCheckoutSizes } from '../../../utils/responsive'
import { useMonitoringWithEnduringEventProperties } from '../../../integrations/monitoring'
import { TrackingEvent } from '../../../model'

export const AddPaymentMethod = (): JSX.Element => {
  const { t } = useTranslation()
  const router = useAppRouter()
  const { textSize, smallTextSize } = useCheckoutSizes()
  const isAppleRetailOrder = useIsAppleRetailOrder()
  const messageContext = isAppleRetailOrder ? 'debitCard' : 'default'
  const { logEvent } = useMonitoringWithEnduringEventProperties()

  const handleAddPaymentMethod = (): void => {
    logEvent(TrackingEvent.PRESSED_PAYMENT_METHOD_NEW_CARD)
    router.push(Route.NEW_PAYMENT_METHOD)
  }

  const components = {
    navLink: <Link kind='Underline' onClick={handleAddPaymentMethod} testNameSpace='add-payment-method' />,
  }

  useEffect(() => {
    router.prefetch(Route.NEW_PAYMENT_METHOD)
  }, [])

  const errorDescription = (
    <Text size={smallTextSize} testNameSpace='add-payment-method'>
      <Trans context={messageContext} i18nKey='summary:addPaymentMethod' components={components} />
    </Text>
  )

  return (
    <Flex alignItems='flex-start' className={styles.container}>
      <ArcadeIcon.CardAdd size='Medium' color='Black' />
      <Flex direction='column' className={styles.textContainer}>
        <Text size={textSize} bold>
          {t('summary:paymentMethodTitle')}
        </Text>
        <MessageInline kind='Error' description={errorDescription} descriptionSize={smallTextSize} testNameSpace='add-payment-method-error' />
      </Flex>
    </Flex>
  )
}
